module.exports = __webpack_public_path__ + "img/bg-header-azul.c95dee94.jpg";